/* @jsxImportSource react */

import * as React from 'react';
import { PriceOldPrice } from '../PriceOldPrice/PriceOldPrice';
import { PriceReductionFlag } from '../PriceReductionFlag/PriceReductionFlag';

const PriceDiscount = ({
  oldPrice,
  discount,
  ...props
}: React.HTMLAttributes<Omit<HTMLDivElement, 'className'>> & {
  oldPrice: string;
  discount?: string;
}) => (
  <div className="price-discount flex [grid-area:b]" {...props}>
    <PriceOldPrice>{oldPrice}</PriceOldPrice>
    {discount && <PriceReductionFlag>{discount}</PriceReductionFlag>}
  </div>
);

PriceDiscount.displayName = 'Price.Discount';

export { PriceDiscount };
